import { render } from "./StudentMapping.vue?vue&type=template&id=7e9af317"
import script from "./StudentMapping.vue?vue&type=script&lang=js"
export * from "./StudentMapping.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__